import { RouteRecordRaw } from "vue-router";

import { IAPHome } from "@/pages/IAP";

import links from "./links";
import { IAPList, PricingTemplateList, PricingTemplateDetails } from "@/modules/IAP";

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: IAPHome,
    name: links.iap.iapHome,
    props: true,
    meta: {
      title: "IAP",
      label: "IAP",
    },
    children: [
      {
        path: "",
        component: IAPList,
        name: links.iap.iapList,
        meta: {
          title: "IAP",
          label: "IAP",
        },
      },
      {
        path: "pricingTemplates",
        component: PricingTemplateList,
        name: links.iap.pricingTemplates,
        props: true,
        meta: {
          title: "IAP | System Pricing Templates",
          label: "System  Pricing Templates",
          showAppTemplates: false,
        },
        children: [
          {
            path: ":templateId",
            component: PricingTemplateDetails,
            name: links.iap.pricingTemplateDetails,
            props: true,
            meta: {
              title: "IAP | System Pricing Templates",
              label: "pricingTemplates",
            },
          },
        ],
      },
      {
        path: "appPricingTemplates",
        component: PricingTemplateList,
        name: links.iap.appPricingTemplates,
        props: true,
        meta: {
          title: "IAP | App Pricing Templates",
          label: "App Pricing Templates",
          showAppTemplates: true,
        },
        children: [
          {
            path: ":templateId",
            component: PricingTemplateDetails,
            name: links.iap.appPricingTemplateDetails,
            props: true,
            meta: {
              title: "IAP | App Pricing Templates",
              label: "appPricingTemplates",
            },
          },
        ],
      },
    ],
  },
];
